/* eslint-disable sort-keys, max-len */
export default {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: 'Für Angebot anmelden',
                signup: 'Für Angebot einschreiben',
                register_long: 'Für Auktion registrieren',
                pending: 'Beantragte Registrierung',
                declined: 'Registrierung abgelehnt',
                closed: 'Los abgeschlossen',
                sent: 'Ihr Angebot wurde gesendet',
                outbid: 'Sie wurden überboten, Angebot {amount}',
                bid: 'Angebot {amount}',
                winning: 'Sie gewinnen',
            },
            conversions: {
                lot_number: 'Los {lotNumber}',
            },
            description: {
                estimate_range: 'Geschätzt {low} - {high}',
                images_label: '{currentImageNumber} / {totalImages}',
            },
            messages: {
                competing_bid_amount: '{amount}: Konkurrierendes Angebot',
                competing_bidder_outbid_by_liveauctioneers_absentee:
                    'Konkurrierender Bieter wurde durch Kaufauftrag von Bieter {paddleNumber} überboten',
                last_bid_retracted: 'Letztes Angebot von {amount} zurückgezogen',
                liveauctioneers_bid_amount: '{amount}: LiveAuctioneers Bieter {paddleNumber}',
                liveauctioneers_bid_amount_absentee: "{amount}: LiveAuctioneers Bieter {paddleNumber}'s Kaufauftrag",
                lot_number_passed: 'Los {lotNumber} genehmigt',
                lot_number_reopened: 'Los {lotNumber} neu eröffnet',
                lot_number_skipped: 'Los {lotNumber} übersprungen',
                lot_number_unsold: 'Los {lotNumber} nicht verkauft',
                lot_opened_asking: 'Los {lotNumber} eröffnet - Ausruf {amount}',
                lot_sold_competing_bidder: 'Los {lotNumber} verkauft für {amount} an konkurrierenden Bieter',
                lot_sold_liveauctioneers_bidder: 'Los {lotNumber} verkauft für {amount} an Bieter {paddleNumber}',
                my_bid_amount: '{amount}: Mein Angebot',
                my_bid_amount_absentee: '{amount}: Mein Kaufauftrag',
                my_bid_retracted: 'Ihr Angebot von {amount} wurde zurückgezogen',
                registration_approved: 'Ihre Registrierung wurde bestätigt',
                reserve_not_met: 'Mindestpreis nicht erreicht',
                you_been_outbid_by_liveauctioneers_absentee:
                    'Sie wurden durch den Kaufauftrag von Bieter {paddleNumber} überboten',
                you_ve_won_lot: 'Sie haben Los {lotNumber} gewonnen',
            },
            missives: {
                fair_warning_lot_about_to_close: 'Fair Warning... Dieses Los wird demnächst geschlossen',
                going_once_going_twice: 'ZUM ERSTEN... ZUM ZWEITEN...',
                third_and_final_warning: 'ZUM DRITTEN UND LETZTE AUFFORDERUNG...',
            },
            status: {
                remaining: 'Es verbleiben {remaining} von {total} Losen',
            },
            thumbnail_scroller: {
                next: 'Nächste Lose',
            },
        },
    },
};
